import React from 'react';
import { RestorePass } from '~/presentation/pages';

export const PasswordFactory: React.FC = () => {
  return <RestorePass />;
};
